import React from "react";
import { useSelector } from "react-redux";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader } from "pages/_components/header";
import Notification from "pages/_components/Notification";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import I18n from "pages/_components/I18n";
import { actions as echeckActions } from "reducers/echecks";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import { statusTagColor } from "util/echecks";
import RequestCacSummaryBody from "./components/Summary";
import InfoTag from "../components/InfoTag";

const RequestCacSummaryPage = () => {
    const { echeqsToDoActions, echeckTicket } = useSelector((state) => state.echecks);
    const willCancel = echeqsToDoActions?.cancelTransaction;

    const documentType = echeqsToDoActions?.echeq?.beneficiario_documento_tipo;
    const documentNumber = echeqsToDoActions?.echeq?.beneficiario_documento;
    const echeq = echeqsToDoActions?.echeq;

    const data = {
        numeroEcheq: echeqsToDoActions?.echeq?.cheque_numero,
        montoTotal: echeqsToDoActions?.echeq?.monto,
        curency: echeqsToDoActions?.echeq?.emisor_moneda,
        idEcheq: echeqsToDoActions?.echeq?.cheque_id,
        document: `${documentType} ${documentNumber}`,
        documentNumber: echeqsToDoActions?.echeq?.beneficiario_documento,
        documentType: echeqsToDoActions?.echeq?.beneficiario_documento_tipo,
        fechaEmision: echeqsToDoActions?.echeq?.fecha_emision,
        fechaPago: echeqsToDoActions?.echeq?.fecha_pago,
        caracter: echeqsToDoActions?.echeq?.cheque_caracter,
        action: echeqsToDoActions?.action,
        echeqList: [echeqsToDoActions?.echeq],
        echeqsToDoActions,
        idTransaction: echeqsToDoActions?.idTransaction,
        estado: echeq?.estado,
    };
    const State = () => (
        <InfoTag type="info" message={echeq?.estado} tagBackground={statusTagColor(echeq?.estado)} tagClass="ml-5" />
    );

    useConfirmTransaction(data, echeckTicket, "echecks/cac");
    return (
        <>
            <Notification scopeToShow="RequestCacSummaryPage" />
            <ResponsiveHeader id="echeq.request.cac" infoComponents={<State />} />
            <MainContainer>
                <div className="container">
                    <h2>
                        <I18n id={willCancel ? "cancel.title" : "echeq.cac.summary"} />
                    </h2>
                    <RequestCacSummaryBody
                        numeroEcheq={echeqsToDoActions?.echeq?.cheque_numero}
                        montoTotal={echeqsToDoActions?.echeq?.monto}
                        curency={echeqsToDoActions?.echeq?.emisor_moneda}
                        idEcheq={echeqsToDoActions?.echeq?.cheque_id}
                        document={`${documentNumber}`}
                        caracter={echeqsToDoActions?.echeq?.cheque_caracter}
                    />
                    <GeneralCredentialForm
                        hideIndications
                        transactionData={data}
                        action={willCancel ? echeckActions.cancelTransfer : echeckActions.requestCac}
                        isCancel={willCancel}
                        idActivity="echeq.request.cac"
                        disableContinueIfEmpty
                    />
                </div>
            </MainContainer>
        </>
    );
};

export default RequestCacSummaryPage;
